import { Component } from "../component"
import { debounce } from "../helpers/debounce"

export class Accordion extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      active: "-active",
    }
  }

  ui() {
    return {
      titles: ".ui-accordion-item-title",
      texts: ".ui-accordion-item-text",
    }
  }

  handleTitleClick(title) {
    const { titles } = this.$ui
    const { active } = this.dynamicClasses

    title.parentNode.classList.toggle(active)
    titles.forEach((el) => {
      if (el !== title) {
        el.parentNode.classList.remove(active)
      }
    })
  }

  setHeights() {
    const { texts } = this.$ui

    texts.forEach((el) => {
      el.style.height = "auto"
      el.style.setProperty("--max-height", `${el.offsetHeight}px`)
      el.style.height = ""
    })
  }

  attachEvents() {
    const { titles } = this.$ui

    window.addEventListener(
      "resize",
      debounce((e) => {
        this.setHeights()
      })
    )

    titles.forEach((title) => {
      title.addEventListener("click", () => {
        this.handleTitleClick(title)
      })
    })
  }

  created() {
    const timeouts = [1, 2, 5, 10, 20, 30, 50]

    this.setHeights()
    timeouts.forEach((timeout) => {
      setTimeout(() => {
        this.setHeights()
      }, timeout * 100)
    })

    this.attachEvents()
  }
}
